<template>
  <div
    v-if="items.length"
    :class="$style.requirements"
    :data-test-id="dataTestId"
  >
    <p :class="$style.heading">
      {{ heading }}
    </p>
    <ul
      :class="$style.list"
      aria-live="polite"
    >
      <li
        v-for="item in items"
        :key="item.id"
        :class="[$style.item, $style[item.status]]"
        :data-test-id="`${dataTestId}__${item.id}`"
      >
        <span
          :class="$style.icon"
          aria-hidden="true"
        >
          <span
            v-if="item.status === 'met'"
            :class="$style.check"
          >✓</span>
          <span
            v-else
            :class="$style.bullet"
          >•</span>
        </span>
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { PASSWORD_REQUIREMENTS_HEADING } from 'client/util/passwordPolicyRequirements';

export default {
  name: 'PasswordRequirementsList',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      default: PASSWORD_REQUIREMENTS_HEADING,
    },
    dataTestId: {
      type: String,
      default: 'password-requirements-list',
    },
  },
};
</script>

<style module>
.requirements {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  width: 100%;
}

.heading {
  color: #5f6368;
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 0.5rem;
  text-align: center;
}

.list {
  display: inline-block;
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: left;
}

.item {
  align-items: flex-start;
  color: #5f6368;
  display: flex;
  font-size: 13px;
  gap: 0.35rem;
  line-height: 1.4;
  margin: 0.15rem 0;
}

.met {
  color: #137333;
}

.pending {
  color: #80868b;
}

.icon {
  display: inline-block;
  flex-shrink: 0;
  text-align: center;
  width: 0.85rem;
}

.check {
  color: #137333;
  font-weight: 700;
}

.bullet {
  color: #80868b;
}
</style>
